import React from 'react';

interface TaxModeSwitchProps {
  showGross: boolean;
  onChange: (showGross: boolean) => void;
}

/**
 * Schiebeschalter Netto / Brutto. Steht im Kopf, gilt für alle Preise.
 */
export default function TaxModeSwitch({ showGross, onChange }: TaxModeSwitchProps) {
  const select = (next: boolean) => {
    if (next !== showGross) onChange(next);
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      select(event.key === 'ArrowRight');
    }
    if (event.key === 'Home') {
      event.preventDefault();
      select(false);
    }
    if (event.key === 'End') {
      event.preventDefault();
      select(true);
    }
  };

  return (
    <div
      className={`sv-tax-switch${showGross ? ' is-gross' : ''}`}
      role="radiogroup"
      aria-label="Preise netto oder brutto anzeigen"
      onKeyDown={onKeyDown}
    >
      <span className="sv-tax-switch-thumb" aria-hidden="true" />
      <button
        type="button"
        role="radio"
        aria-checked={!showGross}
        className="sv-tax-switch-btn"
        onClick={() => select(false)}
      >
        Netto
      </button>
      <button
        type="button"
        role="radio"
        aria-checked={showGross}
        className="sv-tax-switch-btn"
        onClick={() => select(true)}
      >
        Brutto
      </button>
    </div>
  );
}
